export const BlockModeIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 25.0002 37.8652"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M7.47433 13.7582L12.5175 13.7582L17.5088 13.7582M17.5088 13.7582C17.5088 13.7582 19.8245 3.04395 12.5177 3.04395C5.21078 3.04395 7.47433 13.7582 7.47433 13.7582H17.5088Z"
      stroke="#DB4B4D"
      strokeWidth={2.90698}
      strokeLinecap="round"
    />
    <path
      d="M18.75 10.1865C22.2018 10.1865 25 12.9847 25 16.4365V31.6152C24.9999 35.067 22.2017 37.8652 18.75 37.8652H6.25C2.79827 37.8652 7.51824e-05 35.067 0 31.6152V16.4365C0 12.9847 2.79822 10.1865 6.25 10.1865H18.75ZM12.5 15.5439C7.56892 15.544 3.57129 19.5416 3.57129 24.4727C3.57139 29.4037 7.56898 33.4013 12.5 33.4014C17.431 33.4013 21.4286 29.4036 21.4287 24.4727C21.4287 19.5416 17.4311 15.544 12.5 15.5439Z"
      fill="#DB4B4D"
    />
    <path
      d="M7.14307 24.4727L17.8574 24.4727"
      stroke="#DB4B4D"
      strokeWidth={2.90698}
      strokeLinecap="round"
    />
  </svg>
)
